var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.65,18.63c1.9,4.07,2.98,8.59,2.98,13.38c0,17.53-14.21,31.75-31.75,31.75S0.14,49.55,0.14,32.01 c0-17.54,14.22-31.75,31.75-31.75c7.42,0,14.22,2.57,19.62,6.83l-6.05,4.63c-3.88-2.61-8.55-4.13-13.57-4.13 C18.4,7.59,7.47,18.53,7.47,32.01S18.4,56.43,31.89,56.43c13.48,0,24.42-10.94,24.42-24.42c0-2.26-0.33-4.44-0.91-6.52 L60.65,18.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.75,7.59c2.26-1.85,4.2,0.24,2.44,2.44c-5.15,6.44-14.8,17.74-21.03,24.98c0.15,0.6,0.23,1.24,0.23,1.88 c0,4.7-3.81,8.51-8.51,8.51s-8.51-3.81-8.51-8.51s3.81-8.51,8.51-8.51c0.66,0,1.3,0.09,1.91,0.23 C41.02,22.45,52.25,12.89,58.75,7.59z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 51.42,
    cy: 32,
    r: 2.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.65,12.47c1.34,0,2.44,1.09,2.44,2.44s-1.1,2.44-2.44,2.44c-1.35,0-2.44-1.1-2.44-2.44 S40.3,12.47,41.65,12.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.88,10.02c1.35,0,2.44,1.1,2.44,2.44c0,1.34-1.1,2.44-2.44,2.44c-1.35,0-2.44-1.1-2.44-2.44 C29.44,11.12,30.53,10.02,31.88,10.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.11,12.47c1.35,0,2.44,1.09,2.44,2.44s-1.1,2.44-2.44,2.44s-2.44-1.1-2.44-2.44S20.76,12.47,22.11,12.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.78,19.79c1.35,0,2.44,1.1,2.44,2.44s-1.09,2.44-2.44,2.44s-2.44-1.1-2.44-2.44S13.44,19.79,14.78,19.79z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.34,
    cy: 32,
    r: 2.44
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.80612e296e914a2070929972211cb19c.svg";
export { ForwardRef as ReactComponent };